import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";

angular
  .module('bringoz.admin.coordinations')
  .factory('$coordinations', CoordinationsObjectFactory);

/* @ngInject */
function CoordinationsObjectFactory($bringozFactory: $bringozFactory,
                                    coordinationsAPI: BringozApi,
                                    Coordinations_DS: DataStoreConfig) {

  function $coordinations(id: string) {
    return $bringozFactory(id, coordinationsAPI, Coordinations_DS)
  }

  return $coordinations;
}
